import React from 'react';
import { connect } from 'react-redux';
import { IMovementEnquiryProps } from './MovementEnquiry.properties';
import { bindActionCreators, Dispatch } from 'redux';
import { selectors as uiSelectors, actions as uiActions } from 'ducks/ui';
import MovementEnquiry from './MovementEnquiry';
import MovementEnquiryStateProvider from './MovementEnquiry.context';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as staffSelectors } from 'ducks/staff';

const mapStateToProps = (state) => ({
    isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
    isMovementEnquiryLookUpOpen: false, //uiSelectors.isMovementEnquiryLookUpOpen(state),
    staff: staffSelectors.staff(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        toggleMenuOption: uiActions.toggleMenuOption,
        changeOperationMode: operationActions.changeOperationMode,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((props: Readonly<
    IMovementEnquiryProps>) => {
    return (
        <MovementEnquiryStateProvider>
            <MovementEnquiry {...props} />
        </MovementEnquiryStateProvider>
    );
});
